import type { ReactNode } from 'react';

/**
 * Die Wortmarke des Produkts: der Schriftzug „FameAccounting".
 *
 * **Zwei Stellen trugen ihn getrennt** (`W-wortmarke`, 2026-08-28): die
 * Menüspalte (`Sidebar.tsx`) und die Anmeldemaske (`LoginPage.tsx`). Beide
 * meinten denselben Namen mit eigener Zeichenkette UND eigener Klassenliste —
 * ein Tippfehler oder eine Umbenennung hätte eine der beiden Stellen treffen
 * können, ohne dass die andere folgt.
 *
 * **Die Markenregel gehört der Komponente** (`PF-signetbalken`, Markenpaket
 * 1a „Konto-F"): **Fame** in 700, Accounting in 400, Laufweite −3,5 %. Die
 * Gewichte und die Laufweite stehen deshalb an den beiden Teilen und nicht in
 * der Klassenliste des Aufrufers — eine Stelle, die `font-semibold` für das
 * ganze Wort setzte, hätte die Abstufung verwischt, die den Schriftzug
 * ausmacht.
 *
 * **Grösse und Farbe bleiben Sache des Aufrufers** (`className` am äusseren
 * Element): Die Menüspalte und die Anmeldemaske haben verschiedene
 * Schriftgrössen, und eine feste Klasse hier hätte eine von beiden
 * verschoben. Gewicht und Laufweite vererben sich nicht nach unten, weil sie
 * an den Teilen stehen.
 *
 * **Kein `<img>` und kein `<h1>`** — die semantische Rolle (Überschrift,
 * Linktext, o. Ä.) bestimmt weiterhin die aufrufende Stelle über das
 * umgebende Element. Der Text bleibt zusammenhängend „FameAccounting".
 */
export function Wortmarke(props: { readonly className?: string }): ReactNode {
  return (
    <span {...(props.className === undefined ? {} : { className: props.className })}>
      <b className="font-bold tracking-[-0.035em]">Fame</b>
      <span className="font-normal tracking-[-0.035em]">Accounting</span>
    </span>
  );
}
